import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e228754"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold-h3" }, "Verifique o código enviado por email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "informative-form regular-p" }, " Enviamos um código de verificação para o email informadoooo ", -1))
const _hoisted_8 = { class: "d-flex justify-content-center mb-5" }
const _hoisted_9 = { class: "lcts-button" }
const _hoisted_10 = { class: "informative-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "informative-item-1 regular-p" }, "Não recebeu o código de acesso? ", -1))
const _hoisted_12 = { class: "informative-item-2 bold-p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_otp_input, {
            ref: "otpInput",
            value: _ctx.bindModal,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindModal) = $event)),
            "input-classes": "otp-input",
            separator: "",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "numeric"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            onLctsButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleButtonClick(_ctx.form))),
            size: "large",
            styleButton: "secondary",
            text: "Verificar código",
            width: "100%",
            disabled: _ctx.bindModal.length < 5
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("strong", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleResendCode())),
              style: {"cursor":"pointer"}
            }, "Reenviar código")
          ])
        ])
      ])
    ])
  ]))
}